module.exports = __webpack_public_path__ + "img/ui_triangle_down.482849fb.svg";